import React from "react";

//Assets
import poweredbyelco from "../../Assets/poweredbyelco.png";

//UI Material
import { Box } from "@mui/material";

export default function PoweredByElco({ height = "45px" }) {
  return (
    <Box sx={{ marginTop: "20px", marginBottom: "20px" }}>
      <img src={poweredbyelco} height={height} alt="logo atila" />
    </Box>
  );
}
